import {
  createRoadmap,
  updateRoadmap,
  deleteRoadmap,
  createSwimlane,
  updateSwimlane,
  deleteSwimlane,
  createColumn,
  updateColumn,
  deleteColumn,
  addCard,
  moveCard,
  removeCard,
} from "@/backend-api/Roadmap";
import { appApi } from "@/store/slices/appApi";
import type {
  RoadmapCreateRequest,
  RoadmapCreateResponse,
  RoadmapUpdateRequest,
  RoadmapUpdateResponse,
  RoadmapDeleteRequest,
  RoadmapDeleteResponse,
  SwimlaneCreateRequest,
  SwimlaneCreateResponse,
  SwimlaneUpdateRequest,
  SwimlaneUpdateResponse,
  SwimlaneDeleteRequest,
  SwimlaneDeleteResponse,
  ColumnCreateRequest,
  ColumnCreateResponse,
  ColumnUpdateRequest,
  ColumnUpdateResponse,
  ColumnDeleteRequest,
  ColumnDeleteResponse,
  CardAddRequest,
  CardAddResponse,
  CardMoveRequest,
  CardMoveResponse,
  CardRemoveRequest,
  CardRemoveResponse,
} from "@/types/Roadmap";

export const roadmapApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    createRoadmap: builder.mutation<RoadmapCreateResponse, RoadmapCreateRequest>({
      queryFn: async (request) => {
        try {
          const result = await createRoadmap(request);
          return result;
        } catch (error) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: String(error),
              data: error,
            },
          };
        }
      },
      invalidatesTags: [{ type: "Database", id: "roadmaps" }],
    }),
    updateRoadmap: builder.mutation<RoadmapUpdateResponse, RoadmapUpdateRequest>({
      queryFn: async (request) => {
        try {
          const result = await updateRoadmap(request);
          return result;
        } catch (error) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: String(error),
              data: error,
            },
          };
        }
      },
      invalidatesTags: [{ type: "Database", id: "roadmaps" }],
    }),
    deleteRoadmap: builder.mutation<RoadmapDeleteResponse, RoadmapDeleteRequest>({
      queryFn: async (request) => {
        try {
          const result = await deleteRoadmap(request);
          return result;
        } catch (error) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: String(error),
              data: error,
            },
          };
        }
      },
      invalidatesTags: [
        { type: "Database", id: "roadmaps" },
        { type: "Database", id: "roadmap_swimlanes" },
        { type: "Database", id: "roadmap_columns" },
        { type: "Database", id: "roadmap_cards" },
      ],
    }),
    createSwimlane: builder.mutation<SwimlaneCreateResponse, SwimlaneCreateRequest>({
      queryFn: async (request) => {
        try {
          const result = await createSwimlane(request);
          return result;
        } catch (error) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: String(error),
              data: error,
            },
          };
        }
      },
      invalidatesTags: [{ type: "Database", id: "roadmap_swimlanes" }],
    }),
    updateSwimlane: builder.mutation<SwimlaneUpdateResponse, SwimlaneUpdateRequest>({
      queryFn: async (request) => {
        try {
          const result = await updateSwimlane(request);
          return result;
        } catch (error) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: String(error),
              data: error,
            },
          };
        }
      },
      invalidatesTags: [{ type: "Database", id: "roadmap_swimlanes" }],
    }),
    deleteSwimlane: builder.mutation<SwimlaneDeleteResponse, SwimlaneDeleteRequest>({
      queryFn: async (request) => {
        try {
          const result = await deleteSwimlane(request);
          return result;
        } catch (error) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: String(error),
              data: error,
            },
          };
        }
      },
      invalidatesTags: [
        { type: "Database", id: "roadmap_swimlanes" },
        { type: "Database", id: "roadmap_cards" },
      ],
    }),
    createColumn: builder.mutation<ColumnCreateResponse, ColumnCreateRequest>({
      queryFn: async (request) => {
        try {
          const result = await createColumn(request);
          return result;
        } catch (error) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: String(error),
              data: error,
            },
          };
        }
      },
      invalidatesTags: [{ type: "Database", id: "roadmap_columns" }],
    }),
    updateColumn: builder.mutation<ColumnUpdateResponse, ColumnUpdateRequest>({
      queryFn: async (request) => {
        try {
          const result = await updateColumn(request);
          return result;
        } catch (error) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: String(error),
              data: error,
            },
          };
        }
      },
      invalidatesTags: [{ type: "Database", id: "roadmap_columns" }],
    }),
    deleteColumn: builder.mutation<ColumnDeleteResponse, ColumnDeleteRequest>({
      queryFn: async (request) => {
        try {
          const result = await deleteColumn(request);
          return result;
        } catch (error) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: String(error),
              data: error,
            },
          };
        }
      },
      invalidatesTags: [
        { type: "Database", id: "roadmap_columns" },
        { type: "Database", id: "roadmap_cards" },
      ],
    }),
    addCard: builder.mutation<CardAddResponse, CardAddRequest>({
      queryFn: async (request) => {
        try {
          const result = await addCard(request);
          return result;
        } catch (error) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: String(error),
              data: error,
            },
          };
        }
      },
      invalidatesTags: [{ type: "Database", id: "roadmap_cards" }],
    }),
    moveCard: builder.mutation<CardMoveResponse, CardMoveRequest>({
      queryFn: async (request) => {
        try {
          const result = await moveCard(request);
          return result;
        } catch (error) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: String(error),
              data: error,
            },
          };
        }
      },
      invalidatesTags: [{ type: "Database", id: "roadmap_cards" }],
    }),
    removeCard: builder.mutation<CardRemoveResponse, CardRemoveRequest>({
      queryFn: async (request) => {
        try {
          const result = await removeCard(request);
          return result;
        } catch (error) {
          return {
            error: {
              status: "CUSTOM_ERROR",
              error: String(error),
              data: error,
            },
          };
        }
      },
      invalidatesTags: [{ type: "Database", id: "roadmap_cards" }],
    }),
  }),
});

export const {
  useCreateRoadmapMutation,
  useUpdateRoadmapMutation,
  useDeleteRoadmapMutation,
  useCreateSwimlaneMutation,
  useUpdateSwimlaneMutation,
  useDeleteSwimlaneMutation,
  useCreateColumnMutation,
  useUpdateColumnMutation,
  useDeleteColumnMutation,
  useAddCardMutation,
  useMoveCardMutation,
  useRemoveCardMutation,
} = roadmapApi;
